import Loadable from '@loadable/component';

const LoadableSwiper = Loadable(() => import('./component'));

export default LoadableSwiper;
